import { render, staticRenderFns } from "./MilestoneProforma.vue?vue&type=template&id=3fa0ca9e"
import script from "./MilestoneProforma.vue?vue&type=script&lang=js"
export * from "./MilestoneProforma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports